import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/asteroids-frame1.webp";
import video from "../assets/vid/asteroids-video.mp4";
import Video from 'src/components/Video';


export const projectDetails: ProjectInterface = {
    url: "asteroids",
    title: "Asteroids",
    summary: "An asteroids-inspired game made for a college assignment.",
    description: `A copy of the 1979 game Asteroids I did for a college assignment. It features some differences from the original game though, like the wave system and aim with mouse.`,
    year: "2023",
    tags: ["College Assignment", "Arcade", "Shooter", "Unity"],
    imageSrc: cover,
    hasVideo: true,
    startVideoTime: 1,
    videoSrc: video,
    isCoverType: true,
    projectType: ProjectType.COLLEGE,
    people: 1,
    haveTags: true,
    roles: ["Game Programmer"],
    platforms: ["Web"],
    technologies: ["Unity", "C#", "WebGL"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "Same Asteroids, new controls",
    linkData: [
        { type: 'github', url: "https://github.com/lucasctnh/asteroids" },
        { type: 'itchio', url: "https://lcscout.itch.io/asteroids" },
        { type: 'text', url: "https://lcscout.itch.io/asteroids" },
    ],
    relatedProjects: ["ElementalBlitz", "PuzzleCave", "CheckMore"],
};


export function Asteroids() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                        <Video src={video} />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}